import M from 'backbone.marionette'
import T from './adminpunchreports.html'
import T2 from './adminreportlistitem.html'
import Radio from 'backbone.radio';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { minutesToTimeString } from '../../utils/utils';
import moment from 'moment';

export const AdminPunchReports = M.View.extend({
    template: _.template(T),
    initialize: function(){
        
    },
    regions: {
        'report-group':'.report-group'
    },
    events: {
        'click .newPunchReport': 'onNewPunchReportClick',
        'click .btGenererRapport': 'onGenererRapportClick',
    },
    /*
    serializeData: function(){
        const nonTraites = this.getOption('punches').filter(p => !p.get('punchreport_id') && !p.get('validateContributeur_id'))
        const valides = this.getOption('punches').filter(p => !p.get('punchreport_id') && !!p.get('validateContributeur_id'))
        return _.extend(
            this.model.toJSON(),
            {
                nbNonTraites: nonTraites.length,
                minNonTraites: nonTraites.reduce((acc, curr) => { return acc + (curr.get('punchTimeInMinutes') ?? 0)}, 0),
                nbValides: valides.length,
                minValides: valides.reduce((acc, curr) => { return acc + (curr.get('punchTimeInMinutes') ?? 0)}, 0)
            }
        )
    }, */
    onRender: function(){
        this.showChildView('report-group', new M.CollectionView({
            collection: this.getOption('punchreports'),
            childView: ReportListItem,
            childViewOptions: {
                mainModel: this.model
            }
        }))
    },
    onNewPunchReportClick: function(event){
        event.preventDefault();
        event.stopPropagation();
        console.log('onNewPunchReportClick')
        Radio.channel('punch').trigger('loadPunches', null);
    },
    onGenererRapportClick: function(event){
        event.preventDefault();
        event.stopPropagation();
        Radio.channel('punch').trigger('generateReport');
    }
})

const ReportListItem = M.View.extend({
    template: _.template(T2),
    collections: null,
    initialize: function(){
        
    },
    events: {
        'click':'onClick',
        'click .btExcel':'onExcelClick',
    },
    serializeData: function(){
        return _.extend(this.model.toJSON(),
            {
                mainModel: this.getOption('mainModel').toJSON(),
                punchLoaded: !!this.getOption('mainModel').get('loadedPunchReports').get(this.model.get('id')),
                totalString: minutesToTimeString(this.model.get('total'))
            }
        )
    },
    onClick: function(event){
        event.preventDefault();
        event.stopPropagation();
        Radio.channel('punch').trigger('loadPunches', this.model.get('id'));
        this.model.set('status', 'loading');
    },
    onExcelClick: function(event){
        event.preventDefault();
        event.stopPropagation();

        // obtenir tous les punchs au complet
        const allPunches = this.getOption('mainModel').get('punches').filter(p => p.get('punchreport_id') == this.model.get('id'))
        const enseignants = this.getOption('mainModel').get('enseignant');
        const etudiants = this.getOption('mainModel').get('etudiant');
        const competences = this.getOption('mainModel').get('competence');

        let sheets = {
            tous : {total: 0, min: 0, data:[]},
            parCandidat: {},
            parCompetence: {},
            parSpecialiste: {}
        }
        allPunches.forEach(punch => {

            const enseignant = enseignants.get(punch.get('enseignant_id'));
            const etudiant = etudiants.get(punch.get('etudiant_id'));
            const competence = competences.get(punch.get('competence_id'));
            
            sheets.tous.total++;
            sheets.tous.min += punch.get('punchTimeInMinutes');
            sheets.tous.data.push([
                enseignant?.get('NomEnseignant'),
                enseignant?.get('Prenom'),
                etudiant?.get('NomFamille'),
                etudiant?.get('Prenom'),
                competence?.get('CodeCompetence'),
                competence?.get('NomCompetence'),
                punch.get('punchDate'),
                punch.get('punchTimeInMinutes'),
                minutesToTimeString(punch.get('punchTimeInMinutes')),
                punch.get('financesComments')
            ])

            // par candidat
            if(!sheets.parCandidat[punch.get('etudiant_id')]){
                sheets.parCandidat[punch.get('etudiant_id')] = {
                    etudiant: etudiant,
                    total: 0,
                    min: 0,
                    data: []
                }
            }
            sheets.parCandidat[punch.get('etudiant_id')].total++;
            sheets.parCandidat[punch.get('etudiant_id')].min += punch.get('punchTimeInMinutes');
            sheets.parCandidat[punch.get('etudiant_id')].data.push(
                [
                    enseignant?.get('NomEnseignant'),
                    enseignant?.get('Prenom'),
                    competence?.get('CodeCompetence'),
                    competence?.get('NomCompetence'),
                    punch.get('punchDate'),
                    punch.get('punchTimeInMinutes'),
                    minutesToTimeString(punch.get('punchTimeInMinutes')),
                    punch.get('financesComments')
                ]
            );

            // par compétence
            if(!sheets.parCompetence[punch.get('competence_id')]){
                sheets.parCompetence[punch.get('competence_id')] = {
                    competence: competence,
                    total: 0,
                    min: 0,
                    data: []
                }
            }
            sheets.parCompetence[punch.get('competence_id')].total++;
            sheets.parCompetence[punch.get('competence_id')].min += punch.get('punchTimeInMinutes');
            sheets.parCompetence[punch.get('competence_id')].data.push(
                [
                    enseignant?.get('NomEnseignant'),
                    enseignant?.get('Prenom'),
                    etudiant?.get('NomFamille'),
                    etudiant?.get('Prenom'),
                    punch.get('punchDate'),
                    punch.get('punchTimeInMinutes'),
                    minutesToTimeString(punch.get('punchTimeInMinutes')),
                    punch.get('financesComments')
                ]
            );

            // par spécialiste
            if(!sheets.parSpecialiste[punch.get('enseignant_id')]){
                sheets.parSpecialiste[punch.get('enseignant_id')] = {
                    enseignant: enseignant,
                    total: 0,
                    min: 0,
                    data: []
                }
            }
            sheets.parSpecialiste[punch.get('enseignant_id')].total++;
            sheets.parSpecialiste[punch.get('enseignant_id')].min += punch.get('punchTimeInMinutes');
            sheets.parSpecialiste[punch.get('enseignant_id')].data.push(
                [
                    etudiant?.get('NomFamille'),
                    etudiant?.get('Prenom'),
                    competence?.get('CodeCompetence'),
                    competence?.get('NomCompetence'),
                    punch.get('punchDate'),
                    punch.get('punchTimeInMinutes'),
                    minutesToTimeString(punch.get('punchTimeInMinutes')),
                    punch.get('financesComments')
                ]
            );
        })
        
        const wb = XLSX.utils.book_new();

        // Générer la feuille de tous les punchs
        let tousArray = [];
        tousArray.push(['Rapport #',(this.model.get('id')+'').padStart(3, '0')]);
        tousArray.push(['Nom spécialiste', 'Prénom spécialiste', 'Nom étudiant', 'Prénom étudiant', 'Code Compétence', 'Nom Compétence', 'Date', 'Durée en minute', 'Durée hh:mm', 'Notes']);
        tousArray = tousArray.concat(sheets.tous.data);
        tousArray.push(['Total :', sheets.tous.total, '', '', '','', '', sheets.tous.min, minutesToTimeString(sheets.tous.min)]);
        const tousws = XLSX.utils.aoa_to_sheet(tousArray); // or XLSX.utils.json_to_sheet(arrayOfObjects)
        XLSX.utils.book_append_sheet(wb, tousws, "Tous"); // "Sheet1" is the sheet name

        // Générer la feuille par spécialiste
        let parSpecialisteArray = [];
        parSpecialisteArray.push(['Rapport #',(this.model.get('id')+'').padStart(3, '0')]);
        Object.keys(sheets.parSpecialiste).forEach(function(id){
            const data = sheets.parSpecialiste[id];
            if(data.data.length){
                parSpecialisteArray.push(['Enseignant :', data?.enseignant?.get('NomEnseignant'), data?.enseignant?.get('Prenom')]);
                parSpecialisteArray.push(['Nom candidat', 'Prénom candidat', 'Code compétence', 'Nom compétence', 'Date', 'Durée en minute', 'Durée', 'Notes']);
                parSpecialisteArray = parSpecialisteArray.concat(data.data);
                parSpecialisteArray.push(['Total :', data.total, '','','',data.min, minutesToTimeString(data.min)]);
                parSpecialisteArray.push([]);
            }
        })

        const parEnseignantws = XLSX.utils.aoa_to_sheet(parSpecialisteArray); // or XLSX.utils.json_to_sheet(arrayOfObjects)
        XLSX.utils.book_append_sheet(wb, parEnseignantws, "Par enseignant"); // "Sheet1" is the sheet name

        // Générer la feuille par candidat
        let parCandidatArray = [];
        parCandidatArray.push(['Rapport #',(this.model.get('id')+'').padStart(3, '0')]);
        Object.keys(sheets.parCandidat).forEach(function(id){
            const data = sheets.parCandidat[id];
            if(data.data.length){
                parCandidatArray.push(['Étudiant :', data?.etudiant?.get('NomFamille'), data?.etudiant?.get('Prenom')]);
                parCandidatArray.push(['Nom spécialiste', 'Prénom spécialiste', 'Code compétence', 'Nom compétence', 'Date', 'Durée en minute', 'Durée', 'Notes']);
                parCandidatArray = parCandidatArray.concat(data.data);
                parCandidatArray.push(['Total :', data.total, '','','',data.min, minutesToTimeString(data.min)]);
                parCandidatArray.push([]);
            }
        })

        const parCandidatws = XLSX.utils.aoa_to_sheet(parCandidatArray); // or XLSX.utils.json_to_sheet(arrayOfObjects)
        XLSX.utils.book_append_sheet(wb, parCandidatws, "Par candidat"); // "Sheet1" is the sheet name

        // Générer la feuille par competence
        let parCompetenceArray = [];
        parCompetenceArray.push(['Rapport #',(this.model.get('id')+'').padStart(3, '0')]);
        Object.keys(sheets.parCompetence).forEach(function(id){
            const data = sheets.parCompetence[id];
            if(data.data.length){
                parCompetenceArray.push(['Compétence :', data?.competence?.get('CodeCompetence'), data?.competence?.get('NomCompetence')]);
                parCompetenceArray.push(['Nom spécialiste', 'Prénom spécialiste', 'Nom candidat', 'Prénom candidat',  'Date', 'Durée en minute', 'Durée', 'Notes']);
                parCompetenceArray = parCompetenceArray.concat(data.data);
                parCompetenceArray.push(['Total :', data.total, '','','',data.min, minutesToTimeString(data.min)]);
                parCompetenceArray.push([]);
            }
        })

        const parCompetencews = XLSX.utils.aoa_to_sheet(parCompetenceArray); // or XLSX.utils.json_to_sheet(arrayOfObjects)
        XLSX.utils.book_append_sheet(wb, parCompetencews, "Par compétence"); // "Sheet1" is the sheet name

        const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([wbout], { type: 'application/octet-stream' });
        saveAs(blob, "RAC Rapport de temps "+(this.model.get('id')+'').padStart(3, '0')+" " + moment().format('YYYY-MM-DD HH[h]mm') +".xlsx");
    }
})